export default "/images/5fcc2b8f279440b5258fad221d20473e.avif";